export const LINK_IMAGE = {
    LOGO: '/assets/images/sk_logo.png',
    LOGO_AUTOMALL: '/assets/images/automall_logo.png',
    FAVICON_AUTOMALL: '/assets/favicon/automall_favicon.png',
    FAVICON: '/assets/favicon/sk_fav.png',
    NO_FAVICON: '/assets/favicon/no_fav.png',
    BYD_FAVICON: '/assets/icons/byd-logo.svg',
}